module.exports = __webpack_public_path__ + "img/dsci0021.04392b0a.jpg";